import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';
// import { Adal5Service } from 'adal-angular5';
import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//components
import { MessageHandlerComponent } from '../../components/Controls/MessageHandler.component';

//constants
import { Constants } from '../../constants/Constants';

@Component({
    selector: 'my-login',
    templateUrl: './Login.component.html'
})
export class LoginComponent implements OnInit {

    userName: string;
    password: string;
    redirectUrl: string;

    returnUrl: string = 'container';

    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;

    constructor( private authenticationService: serv.AuthenticationService, private employeeService: serv.EmployeeService,
        private domainDataService: serv.DomainDataService, private router: Router, private route: ActivatedRoute, private configService: serv.ConfigService) {

        this.userName = "";
        this.password = "";

        this.redirectUrl = this.configService.appConfig.LoginRedirectUrl;
    }

    shouldRedirect(): boolean {
        return this.redirectUrl != "";
    }



    ngOnInit(): void {

        localStorage.removeItem('currentUser');
        this.authenticationService.logout();
    }

    authenticateUser(): void {
        this.authenticationService
            .authenticateUser()
            .subscribe(x=>this.finalizeLogin(x));
    }

    onLoginClick(event: any): void {

        var filter: filters.EmployeeFilter = { Username: this.userName, Password: this.password, IncludeInactive: false };
        if (this.userName.trim() == "" || this.password.trim() == "") {
            var response: ent.Response = { Success: false, ValidationMessages: [{ Category: '', MessageText: 'Please enter a Username and Password.' }] };
            this.messageHandlerComponent.handleResponse(response);
        }
        else {
            var filter: filters.EmployeeFilter = { Username: this.userName, Password: this.password };

            this.authenticateUser();
        }

    }

    onRedirectClick(event: any): void {

        window.location.href = this.returnUrl;

    }


    onResetClick(event: any): void {

        this.userName = "";
        this.password = "";
    }

    finalizeLogin(authenticationResult: ent.AuthenticationResult): void {
        if (authenticationResult.Success) {

            // store username in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify({
                salesOffice: authenticationResult.Employee.SalesOffice,
                employee: authenticationResult.Employee,
                features: authenticationResult.Employee.Features,
                appSettings: authenticationResult.AppSettings
            }));

            this.domainDataService.getVendSizeFlavorXrefs({}).subscribe(x=>{
                localStorage.setItem('vendSizeFlavorXrefs', JSON.stringify({x}));

                var salesOfficeFilter: filters.SalesOfficeFilter = {IncludeInactive: false};
                this.domainDataService.getSalesOffices(salesOfficeFilter).subscribe(x=>{
                    localStorage.setItem('salesOffices', JSON.stringify({x}));

                    var response: ent.Response = { Success: true, ValidationMessages: [{ Category: '', MessageText: 'Login: ' + authenticationResult.Employee.Username }] };

                    this.router.navigate([this.returnUrl]);
                });
            });
        }
        else {
            var response: ent.Response = { Success: false, ValidationMessages: [{ Category: '', MessageText: 'Login Failed: ' + authenticationResult.Employee.Username }] };
            this.messageHandlerComponent.handleResponse(response);
        }


    }



}